import * as tslib_1 from "tslib";
import { jsonArrayMember, jsonMember, jsonObject } from "typedjson";
/**
 * Усовие фильтрации
 *
 */
let PitRequestCriteriaFilter = class PitRequestCriteriaFilter {
    constructor(fields) {
        /** Массив значений фильтрации для поля, приведенных к строковому типу */
        this._filterValues = [];
        /** Массив значений фильтрации для поля, приведенных к строковому типу */
        this.values = [];
        if (fields)
            Object.assign(this, fields);
    }
    get field() {
        return this._field;
    }
    set field(value) {
        this._field = value;
    }
    get condition() {
        return this._condition;
    }
    set condition(value) {
        this._condition = value;
    }
    get filterValue() {
        return this._filterValue;
    }
    set filterValue(value) {
        this._filterValue = value;
    }
    get filterValues() {
        return this._filterValues;
    }
    set filterValues(value) {
        this._filterValues = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "field", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaFilter.prototype, "_field", void 0);
tslib_1.__decorate([
    jsonMember({ name: "condition", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaFilter.prototype, "_condition", void 0);
tslib_1.__decorate([
    jsonMember({ name: "filterValue", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaFilter.prototype, "_filterValue", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { name: "filterValues", emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestCriteriaFilter.prototype, "_filterValues", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitRequestCriteriaFilter.prototype, "value", void 0);
tslib_1.__decorate([
    jsonArrayMember(String, { emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Array)
], PitRequestCriteriaFilter.prototype, "values", void 0);
PitRequestCriteriaFilter = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], PitRequestCriteriaFilter);
export { PitRequestCriteriaFilter };
